<template>
    <div>
        <!-- 标题 -->
        <div class="agw-title">
            <Breadcrumb>
                <BreadcrumbItem>{{this.$route.query.accountTypeName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.accountName}}</BreadcrumbItem>
                <BreadcrumbItem>{{this.$route.query.name}}</BreadcrumbItem>
                <BreadcrumbItem to="/network/agwMonitor">{{$t('alarms.network.AppGateway.title')}}</BreadcrumbItem>
                <BreadcrumbItem>
                    <a @click="ipAddress">{{ $t('alarms.common.monitoringSummary') }}</a>
                </BreadcrumbItem>
            </Breadcrumb>
        </div>
        <!-- 查询框 -->
        <div class="agw-top">
            <Row :gutter="16">
                <Col span="12">
                    <Select v-model="timeType" @on-change="changeTimeTypeAzure(timeType)">
                        <Option v-for="item in timeList" :value="item.id" :key="item.id">{{item.name}}</Option>
                    </Select>
                </Col>
            </Row>
        </div>
        <!-- 折线图 -->
        <Row :gutter="16">
            <Col span="12" v-for="(item,index) in list" :key="index">
                <Card :padding="8">
                    <p slot="title">{{item.title}}</p>
                    <a href="#" slot="extra" @click.prevent="changeFull(item)">
                        <Icon type="ios-expand" size="18"/>
                    </a>
                    <div :id="item.id" :ref="item.id" style="width:100%;height: 240px;"></div>
                </Card>
            </Col>
        </Row>
        <!-- 放大弹出框 -->
        <Modal v-model="isShowModal" :mask-closable="false" :closable="false" width="65%">
            <Row>
                <Col span="24">
                    <h3>{{lineTitle}}</h3>
                    <div id="chart-part" ref="fullChart" style="width:100%; height:420px;"></div>
                </Col>
            </Row>
            <div slot="footer">
                <div>
                    <Button @click="cancel">{{$t('alarms.common.close')}}</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import {setCookie,getCookie} from '../../../../../utils/cookieUtil.js'
    export default {
        name: 'AGW',
        data () {
            return {
                // 放大功能
                lineTitle:'',
                isShowModal: false,
                //折线图
                list: [{
                    id: 'throughput',
                    title:this.$t('alarms.network.AppGateway.line.ThroughputByte')
                },
                {
                    id: 'numberOfConnections',
                    title:this.$t('alarms.network.AppGateway.line.NumberOfConnectionsCount')
                }],
                timeType:0,
                timeList:[],
                id:'',
                accountId:'',
                accountTypeName:'',
                accountName:'',
                region:'',
                privateIp:'',
                // echarts实例
                chartThroughput:'',
                chartNumberOfConnections:'',
                throughputOption:{},
                numberOfConnectionsOption:{},
                //Azure数组
                throughputs:[],
                currentConnections:[],
                xaxisData:[]
            }
        },
        mounted: function(){
            this.queryTimeHorizon();
            // 自适应不同屏幕尺寸
            const self=this;
            window.addEventListener("resize",function(){
                self.chartThroughput.resize();
                self.chartNumberOfConnections.resize();
            });
        },
        created(){
            this.checkAzureVmIndex();
        },
        methods: {
            /******************放大********************************/
            changeFull:function(item){
                this.isShowModal=true;
                this.lineTitle=item.title;
                this.$nextTick(() => {
                    const chartFul = this.$refs.fullChart;
                    if(chartFul){
                        const fullChart = this.$echarts.init(
                            document.getElementById("chart-part")
                        );
                        fullChart.clear();
                        if(item.id=='throughput'){
                            var optionFll = this.throughputOption;
                        }else if(item.id=='numberOfConnections'){
                            var optionFll = this.numberOfConnectionsOption;
                        }
                        
                        fullChart.setOption(optionFll);
                        window.addEventListener("resize", function() {
                            fullChart.resize();
                        });    
                    }
                });
            },
            // 模态框取消事件
            cancel() {
                this.isShowModal = false;
            },
            /******************查询********************************/
            // 查询时间范围
            queryTimeHorizon: function(){
                this.$api.cloudWatch.queryTimeHorizon("userName",getCookie(global.cookieName))
                .then(res => {
                    this.timeList = res.data;
                })
            },
            // Azure折线图
            checkAzureVmIndex: function(){
                this.$api.cloudWatch.checkAzureApplicationGatewayStatistics({
                    "accountId":this.$route.query.accountId,
                    "timeHorizon":this.timeType,
                    "monitorModule":23,
                    "name":this.$route.query.name
                })
                .then(res => {
                    // Azure
                    this.xaxisData=res.data.xaxisData;
                    this.throughputs=res.data.throughput;
                    this.currentConnections=res.data.currentConnections;
                    this.allAzure();
                })
            },
            changeTimeTypeAzure:function(){
                this.checkAzureVmIndex();
            },
            /******************所有折线图********************************/
            allAzure:function(){
                this.throughputLine();
                this.numberOfConnectionsLine();
            },
            /*************Azure折线图*****************************/
            // 吞吐量（Byte）
            throughputLine:function(){
                this.chartThroughput=this.$echarts.init(document.getElementById("throughput"));
                this.throughputOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 吞吐量
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('alarms.network.AppGateway.line.Throughput')]
                    },
                    series: [{
                        name:this.$t('alarms.network.AppGateway.line.Throughput'),
                        type:'line',
                        data:this.throughputs,
                        itemStyle: {
                            normal: {
                                color: "#91c7ae",
                                lineStyle: {
                                    color: "#91c7ae"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartThroughput.setOption(this.throughputOption)
            },
             // 连接数（个）
            numberOfConnectionsLine:function(){
                this.chartNumberOfConnections=this.$echarts.init(document.getElementById("numberOfConnections"));
                this.numberOfConnectionsOption={
                    tooltip : {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            label: {
                                backgroundColor: '#6a7985'
                            }
                        }
                    },
                    // 连接数
                    legend: {
                        x: 'right',
                        y: '10px',
                        data:[this.$t('alarms.network.AppGateway.line.NumberOfConnections')]
                    },
                    series: [{
                        name:this.$t('alarms.network.AppGateway.line.NumberOfConnections'),
                        type:'line',
                        data:this.currentConnections,
                        itemStyle: {
                            normal: {
                                color: "#ceca58",
                                lineStyle: {
                                    color: "#ceca58"
                                }
                            }
                        }
                    }],
                    grid: {
                        top:'20%',
                        left: '3%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis : [
                        {
                            type : 'category',
                            boundaryGap : false,
                            data: this.xaxisData.map(function (str) {
                                return str.replace(' ', '\n')
                            })
                        }
                    ],
                    yAxis : [
                        {
                            splitNumber:4,
                            type : 'value'
                        }
                    ]
                }
                this.chartNumberOfConnections.setOption(this.numberOfConnectionsOption)
            },
            /********************************/
            // 点击返回详情页
            ipAddress: function(){
                this.id = this.$route.query.id;
                this.accountId=this.$route.query.accountId;
                this.region=this.$route.query.region;
                this.privateIp=this.$route.query.privateIp;
                this.accountTypeName=this.$route.query.accountTypeName;
                this.accountName=this.$route.query.accountName;
                this.name=this.$route.query.name;
                this.$router.push({path:'/network/agwDetail/',query: {id: this.id,accountId:this.accountId,region:this.region,privateIp:this.privateIp,accountTypeName:this.accountTypeName,accountName:this.accountName,name:this.name}});
            }
        }
    }
</script>

<style scoped>
    .agw-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 15px 4px;
        font-weight: 600;
    }
    .ivu-col-span-12
    {
        margin-bottom: 20px;
    }
    .agw-top
    {
        width: 100%;
        height: 53px;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/agw/agw_dashboard/AGW.vue